import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  htmlFontSize: 12,
  fontSize: 11,
  fontFamily: '"Noto Sans JP", sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    fontSize: '2.5rem',
  },
  h2: {
    fontWeight: 400,
    fontSize: '2rem',
  },
  h3: {
    fontWeight: 400,
    fontSize: '1.75rem',
  },
  h4: {
    fontWeight: 400,
    fontSize: '1.5rem',
  },
  h5: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  h6: {
    fontWeight: 500,
    fontSize: '0.8rem',
  },
  body1: {
    fontWeight: 400,
    fontSize: '0.8rem',
    lineHeight: 1.43,
  },
  body2: {
    fontWeight: 300,
    fontSize: '0.8rem',
    lineHeight: 1.43,
  },
};
